var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3w"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14583",
    d: "M29.0787 13.0698C29.6349 11.6796 29.6349 9.9458 29.0787 8.5558C28.2922 6.5895 26.7035 4.75936 24.8048 3.94496C23.4622 3.36926 21.4515 3.36926 20.1089 3.94496C18.2102 4.75936 16 8.33082 16 8.33082C16 8.33082 13.7898 4.75936 11.8911 3.94496C10.5485 3.36926 8.53776 3.36926 7.1952 3.94496C5.29651 4.75936 3.70775 6.5895 2.92124 8.5558C2.36512 9.9458 2.36512 11.6796 2.92124 13.0698C4.92076 18.0683 12.9244 25.9434 15.3195 28.2295C15.6932 28.5862 16.3068 28.5862 16.6806 28.2295C19.0758 25.9433 27.0792 18.0683 29.0787 13.0698Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14585",
    d: "M4.00708 18.5H7.14952C7.70678 18.5 8.25302 18.3448 8.72702 18.0518C9.20101 17.7587 9.58403 17.3394 9.83312 16.8409L11.0029 14.5L14.0011 22.5L16 12.5L17.9988 22.5L20.097 19.7007C20.3764 19.3279 20.7388 19.0253 21.1555 18.8169C21.5722 18.6085 22.0316 18.5 22.4975 18.5H27.9928",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthActive);
export default __webpack_public_path__ + "static/media/healthActive.9457973e7fd425e450f5ab9a1ccfcaed.svg";
export { ForwardRef as ReactComponent };